/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseAutoAction } from '../models/api-response-auto-action';
import { ApiResponseListAutoAction } from '../models/api-response-list-auto-action';
import { findDefaultActionSettings } from '../fn/auto-action-api/find-default-action-settings';
import { FindDefaultActionSettings$Params } from '../fn/auto-action-api/find-default-action-settings';
import { updateDefaultAction } from '../fn/auto-action-api/update-default-action';
import { UpdateDefaultAction$Params } from '../fn/auto-action-api/update-default-action';
import { updateSpecificDefaultAction } from '../fn/auto-action-api/update-specific-default-action';
import { UpdateSpecificDefaultAction$Params } from '../fn/auto-action-api/update-specific-default-action';

@Injectable({ providedIn: 'root' })
export class AutoActionApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateSpecificDefaultAction()` */
  static readonly UpdateSpecificDefaultActionPath = '/v1/api/ui/auto-actions/media';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSpecificDefaultAction()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateSpecificDefaultAction$Response(params: UpdateSpecificDefaultAction$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseAutoAction>> {
    return updateSpecificDefaultAction(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSpecificDefaultAction$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateSpecificDefaultAction(params: UpdateSpecificDefaultAction$Params, context?: HttpContext): Observable<ApiResponseAutoAction> {
    return this.updateSpecificDefaultAction$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseAutoAction>): ApiResponseAutoAction => r.body)
    );
  }

  /** Path part for operation `updateDefaultAction()` */
  static readonly UpdateDefaultActionPath = '/v1/api/ui/auto-actions/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateDefaultAction()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDefaultAction$Response(params: UpdateDefaultAction$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListAutoAction>> {
    return updateDefaultAction(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateDefaultAction$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateDefaultAction(params: UpdateDefaultAction$Params, context?: HttpContext): Observable<ApiResponseListAutoAction> {
    return this.updateDefaultAction$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListAutoAction>): ApiResponseListAutoAction => r.body)
    );
  }

  /** Path part for operation `findDefaultActionSettings()` */
  static readonly FindDefaultActionSettingsPath = '/v1/api/ui/auto-actions/{refPhoneCompany}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findDefaultActionSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  findDefaultActionSettings$Response(params: FindDefaultActionSettings$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListAutoAction>> {
    return findDefaultActionSettings(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findDefaultActionSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findDefaultActionSettings(params: FindDefaultActionSettings$Params, context?: HttpContext): Observable<ApiResponseListAutoAction> {
    return this.findDefaultActionSettings$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListAutoAction>): ApiResponseListAutoAction => r.body)
    );
  }

}
